import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sim-detail-section',
  imports: [],
  templateUrl: './detail-section.component.html',
  styleUrl: './detail-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'detail-section'
  }
})
export class SimDetailSectionComponent {
  readonly heading = input<string>('');
}
